import { render, staticRenderFns } from "./BinanceExchangeInput.vue?vue&type=template&id=1938377f&"
import script from "./BinanceExchangeInput.vue?vue&type=script&lang=ts&"
export * from "./BinanceExchangeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports